import { v4 as uuidv4 } from 'uuid';

export class MockPost {
    id = uuidv4();
    datetimestamp = "2011-10-05T14:48:00.000Z";
    eventType = "Event";
    type = "Infrastructure - Operations";
    typeColor = MockPost.getRandomColor();
    title = "";
    message = "No message";
    readCount = 2;
    totalCount = 33;
    user: Object = MockPost.getRandomUser();

    constructor(post: { 
        datetimestamp?: string, 
        eventType?: string, 
        type?: string, 
        typeColor?: string,
        title?: string,
        message?: string,
        readCount?: number,
        totalCount?: number,
        user?: {
            name?: string,
            initial?: string
        }
    }) {
        this.datetimestamp = post.datetimestamp || this.datetimestamp;
        this.eventType = post.eventType || this.eventType;
        this.type = post.type || this.type;
        this.typeColor = post.typeColor || this.typeColor;
        this.title = post.title || this.title;
        this.message = post.message || this.message;
        this.readCount = post.readCount || this.readCount;
        this.totalCount = post.totalCount || this.totalCount;
        this.user = post.user || this.user;
    }

    static getRandomUser(): Object {
        const users = [
            {
                name: "Roger J",
                initial: "R"
            },
            {
                name: "Ginger K",
                initial: "G"
            }
        ];
        return users[Math.floor(Math.random() * users.length)];
    }

    static getRandomColor(): string {
        const colors = [
            "#E63946",
            "#457b9d",
            "#cb997e",
            "#cb997e",
            "#f4a261",
            "#ffb703",
            "#003049",
            "#b5838d",
            "#ef476f",
            "#ffd166",
            "#118ab2",
            "#dda15e",
            "#8d99ae",
            "#355070",
            "#89b0ae",
            "#40916c",
            "#9d8189",
            "#cb997e",
            "#6b705c",
            "#03071e",
            "#d00000",
            "#e85d04",
            "#00296b",
            "#00509d",
            "#22223b",
            "#9a8c98",
            "#c9ada7",
            "#f07167",
            "#161a1d",
            "#c8553d",
            "#588157",
            "#5f0f40"
        ];
        return colors[Math.floor(Math.random() * colors.length)];
    }
}
